import highchart, { setOptions } from 'highcharts/highstock';
import HighChart from 'highcharts-react-official';
import drilldown from 'highcharts/modules/drilldown';
import { Box, Typography } from '@mui/material';
import './Chart.scss';
import constant from '../../../utils/constants';
import { Icon } from '@iconify/react';
import { NoDataToDisplay } from 'react-highcharts-no-data-to-display';

drilldown(highchart);
NoDataToDisplay(highchart);
setOptions({
  lang: {
    thousandsSep: ''
  }
});

const Chart = ({
  options,
  showTypography
}: {
  options: any;
  showTypography: boolean;
}) => {
  // Extracting series data from options
  const seriesData = options?.series?.[0]?.data ?? [];
  return (
    <>
      {showTypography ? (
        <Box className={options.chart?.type !== 'areaspline' ? 'chart-card-box' : ''}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginRight: '20px'
            }}
          >
            <HighChart highcharts={highchart} options={options} />
            <Box>
              {seriesData?.map((item: any, index: number) => (
                <Box
                  key={index}
                  sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                >
                  <Icon
                    icon={`mdi:dot`}
                    width='40'
                    height='40'
                    style={{ color: item.z === 'In' ? '#6167FD' : '#ff7373' }}
                  />
                  <Typography className='chart-geo-value'>{item.name}</Typography>
                  <Typography className='chart-geo'>
                    {item.z === 'In' ? constant.vehicleGeoIn : constant.vehicleGeoOut}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box className={options.chart?.type !== 'areaspline' ? 'chart-card-box' : ''}>
          <HighChart highcharts={highchart} options={options} />
        </Box>
      )}
    </>
  );
};

export default Chart;
